// extracted by mini-css-extract-plugin
export default {"control":"control_control__IKHSb","button":"control_button__3Z68X"};